<template>
    <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    class="teacher_from"
    label-width="121px"
    size="large"
    
    status-icon>
        <el-form-item label="老师姓名" prop="name" class="name">
            <el-input
            v-model="ruleForm.name"
            placeholder="请输入老师姓名"
            class="big_input"
            ></el-input>
        </el-form-item>
        <el-form-item label="QQ号码" prop="qqNumber" 
        class="qqNumber">
            <el-input
            v-model="ruleForm.qqNumber"
            placeholder="请输入QQ号码"
            class="big_input"
            ></el-input>
        </el-form-item>
        <el-form-item label="QQ链接" prop="qqUrl" class="qqUrl">
            <el-input
            v-model="ruleForm.qqUrl"
            placeholder="请输入QQ链接"
            class="big_input"
            ></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="telNumber" class="telNumber">
            <el-input
            v-model="ruleForm.telNumber"
            placeholder="请输入电话号码"
            class="big_input"
            ></el-input>
        </el-form-item>
        <el-form-item
          label="微信二维码图片"
          prop="weiXinUrl"
        >
            <ImgUpload
            :type="2"
            :limit="1"
            ref="backgroundImg"
            :imagePath="ruleForm.weiXinUrl"
            @change-image="changeImage"
            ></ImgUpload>
        </el-form-item>
        <el-form-item label="备注说明" class="remarks">
            <el-input v-model="ruleForm.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" placeholder="请输入备注说明"/>
        </el-form-item>
    </el-form>
    <div slot="footer" class="from_btn button">
        <el-button @click="onCancel" size="large">取消</el-button>
        <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
        :disabled = "submitDisabled">提交保存</el-button>
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>
</template>

<script>
import {
    AddTeacher,
    EditTeacher
} from "@/network/teacherScheduling.js";
import ImgUpload from "components/ImgUploadNew.vue";
import WangEditor from "components/wangEditor/WangEditor.vue";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { isHttp } from '@/common/utils.js'
import { telreg } from '@/common/const.js'
export default {
    name: "AddEditBackground",
    components: {
        ImgUpload,
        WangEditor
    },
    emits: {
        "close-dialog": null,
        "update-list": null,
    },
    props: {
        editId: {
            type: Number,
            default: 0,
        },
        imgObj: Object,
    },
    setup(props, { emit }) {
        const data = reactive({
            loading: false,
            ruleForm: {
                name: '',
                qqNumber: null,
                qqUrl:null,
                telNumber:null,
                weiXinUrl: "",
                remarks:'',
            },
            rules: {
                name: [
                    { required: true, message: '请填写老师姓名', trigger: ['blur','change'] },
                ],
                qqNumber: [
                    { required: true, message: '请填写QQ号码', trigger: ['blur','change'] },
                    {
                        validator: (rule, value, callback) => {
                            
                            let Expression = /^\d+$/
                            var objExp = new RegExp(Expression);
                            if (objExp.test(data.ruleForm.qqNumber)) {
                                callback();
                            } else {
                                callback(new Error("QQ号码只能是数字"));
                            }
                        }
                    }
                ],
                qqUrl: [
                    { required: true, message: '请填写QQ链接', trigger: ['blur','change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (isHttp(data.ruleForm.qqUrl)) {
                                callback();
                            } else {
                                callback(new Error("请输入正确的QQ链接"));
                            }
                        }
                    }
                ],
                telNumber: [
                    { required: true, message: '请填写电话号码', trigger: ['blur','change'] },
                    {
                        validator: (rule, value, callback) => {
                            
                            if (!telreg.test(value)) {
                                return callback(new Error('请输入正确的11位数手机号码！'));
                            } else {
                                callback();
                            }
                        }
                    }
                    
                ],
                weiXinUrl: [
                    {
                        required: true,
                        message: "请上传微信二维码图片",
                        trigger: "change",
                    },
                    {
                        validator: (rule, value, callback) => {
                            if (
                                data.ruleForm.weiXinUrl === "" ||
                                data.ruleForm.weiXinUrl === undefined ||
                                data.ruleForm.weiXinUrl === null
                            ) {
                                callback(new Error("请上传微信二维码图片"));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
            },
            submitDisabled:false
        });


        //编辑请求院校详情
        if (props.imgObj && props.editId > 0) {
            data.ruleForm = props.imgObj;
        } else {
        }
        
        const ruleFormRef = ref();
        const backgroundImg = ref();

        const onCancel = () => {
            emit("close-dialog");
            ruleFormRef.value.resetFields();
            // 关闭弹窗 判断图片删除
            if (backgroundImg.value) {
                backgroundImg.value.cancelData();
            }
        };

        //获取图片上传组件传过来的
        const changeImage = (arr) => {
            if (arr && arr.length > 0) {
                data.ruleForm.weiXinUrl = arr[0].url;
                ruleFormRef.value.clearValidate("weiXinUrl");
            } else {
                data.ruleForm.weiXinUrl = "";
            }
        };

        const submitForm = async () => {
            const form = unref(ruleFormRef);
            if (!form) return;
            try {
                const valid = await form.validate();
                if (!valid) {
                    return false;
                } else {
                    data.submitDisabled=true;
                    updataAdd(data.ruleForm).then(() => {
                        data.submitDisabled = false;
                    });
                }
            } catch (error) {
                ElMessage.error("有必填内容未填写！");
            }
        };

        const updataAdd = async (val) => {
            data.loading = true;
            let result = "";
            if (props.editId > 0) {
                let obj = val
                obj.id = props.editId
                result = await EditTeacher(obj);
            } else {
                result = await AddTeacher(val);
            }
            if (result && result.code == 1) {
                data.loading = false;
                ElMessageBox.alert(result.message, props.editId ? "编辑" : "添加", {
                confirmButtonText: "确定",
                });
                if (backgroundImg.value) {
                    backgroundImg.value.submitData(data.ruleForm.weiXinUrl);
                }
                emit("close-dialog");
                emit("update-list");
            } else {
                data.loading = false;
                ElMessageBox.alert(result.message, props.editId ? "编辑" : "添加", {
                confirmButtonText: "确定",
                });
            }
        };
       

        return {
        ...toRefs(data),
        ruleFormRef,
        backgroundImg,
        onCancel,
        changeImage,
        submitForm,
        updataAdd,
        };
    }
}
</script>

<style scoped>
.teacher_from{
    width: 100%;
    height: 600px;
    padding: 0 30px 20px 0;
    /* overflow-y:scroll; */
}
.big_input{
    width: 300px;
}
</style>